<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            @action="masterAction"
            ref="masterComponent"
            :actions="false"
  >
  </g-master>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        loadingTemplate: false,
        loadingBtns: {},
        master: {
          endpoint: 'distribution_cc_hist_load',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado en', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado en', dataIndex: 'modified_on', sorter: true},
              {title: 'Consecutivo de cargue', dataIndex: 'dist_document', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                },
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            }
          }
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            this.deleteLoad(action.record)
            break
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      deleteLoad (record) {
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea eliminar este cargue?',
          onOk: () => {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().delete('distribution_cc_hist_load/' + record.dist_document, {
              })
                .then(() => {
                  this.$emit('loadData')
                  this.loadData()
                  resolve()
                })
                .catch((error) => {
                  Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible eliminar el cargue'))
                  reject(error)
                })
            })
          },
          onCancel () { }
        })
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().get('distribution_cc_hist_load/download/' + record.id, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      loadData () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueHistoricoDist.vue